import { AddToCartButtonType } from '@commerce-cart-webcomponents/ui-composite';
import { Button, ButtonStyles, ButtonWidth, useTranslation } from '@nextgen-web-framework/all';
import AddToCartButton from '../AddToCartButton/AddToCartButton';
import styles from './AddToCartWithSubscribe.module.scss';
import { type AddToCartWithSubscribeProps } from './types/propsType';

export const AddToCartWithSubscribe = (props: AddToCartWithSubscribeProps) => {
  const t = useTranslation();
  const subscribeButtonTitle = t('product.addToCartWithSubscribe.subscribeTitle');

  return (
    <div
      className={styles['add-to-cart-with-subscription-container']}
      data-testid="add-to-cart-with-subscription-container"
    >
      <div className={styles['add-to-cart-with-subscription-container-button']}>
        <Button
          disabled={props.disableSubscribeButton}
          buttonWidth={ButtonWidth.FULL_WIDTH}
          buttonStyle={ButtonStyles.OUTLINE}
          onClick={props.onSubscribeClick}
          title={subscribeButtonTitle}
          data-testid="add-to-cart-subscribe-btn"
        />
      </div>
      <div className={styles['add-to-cart-with-subscription-container-button']}>
        <AddToCartButton {...props} addToCartButtonType={AddToCartButtonType.ADD_TO_CART_WITH_SUBSCRIBE} />
      </div>
    </div>
  );
};

export type { AddToCartWithSubscribeProps };
